import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  button_contained: {
    backgroundColor: "white",
  },
  button_outlined: {
    border: "1px solid white",
    color: "white",
  },
  wrapper: {
    margin: "0 64px 0 64px",
  },
}));
